import { useEffect, useState } from 'react';
import { FileText, ExternalLink } from 'lucide-react';
import { getQuoteDocs } from '@/services/quotes.service.js';
import { formatHumanDate } from '@/lib/format.js';
import { openDocument } from '@/lib/openDocument.js';

// COVERAGE-LINE-ENVELOPE-SPEC §7 Slice 5 (gap A) — source quote PDFs attached to
// this deal's quotes via the /drop-pdf quote-attach pipeline (confirmed_type
// 'quote', status 'actioned'). Read-only WorkDrive links; renders nothing when
// there are none, so it's a no-op on deals without attached source docs.
export default function QuoteSourceDocs({ dealId }) {
  const [docs, setDocs] = useState([]);

  useEffect(() => {
    if (!dealId) return undefined;
    let live = true;
    getQuoteDocs(dealId)
      .then((r) => { if (live) setDocs(Array.isArray(r?.documents) ? r.documents : []); })
      .catch(() => { if (live) setDocs([]); });
    return () => { live = false; };
  }, [dealId]);

  if (!docs.length) return null;

  return (
    <div className="mt-2 space-y-1">
      {docs.map((d) => (
        <button
          type="button"
          key={d.id}
          onClick={() => openDocument(d.workdrive_permalink)}
          disabled={!d.workdrive_permalink}
          className="flex items-center gap-1.5 text-left text-[11px] text-accent hover:underline"
          title="Open the carrier's source quote PDF in WorkDrive"
        >
          <FileText className="h-3 w-3 shrink-0" />
          <span>
            Source quote PDF{d.carrier ? ` — ${d.carrier}` : ''}
            {d.received_at ? ` (${formatHumanDate(d.received_at)})` : ''}
          </span>
          <ExternalLink className="h-3 w-3 shrink-0 opacity-60" />
        </button>
      ))}
    </div>
  );
}
